// extracted by mini-css-extract-plugin
export var casesList = "cases-list-module--cases-list--yOlbW";
export var casesList__slider = "cases-list-module--cases-list__slider--nBqIB";
export var casesList__container = "cases-list-module--cases-list__container--e9-bj";